import React from 'react';
import { Button } from './Button';
import { FileText, Zap, BookOpen } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-8 pb-12 md:pt-16 md:pb-20 overflow-hidden bg-[#FAF7F2]" data-id="element-151">
      {/* Italian Flag Top Accent */}
      <div className="absolute top-0 left-0 w-full h-1.5 md:h-2 flex" data-id="element-152">
        <div className="flex-1 bg-brand-green" data-id="element-153"></div>
        <div className="flex-1 bg-white" data-id="element-154"></div>
        <div className="flex-1 bg-brand-red" data-id="element-155"></div>
      </div>

      <div className="max-w-3xl mx-auto px-5 sm:px-6 lg:px-8 text-center" data-id="element-156">
        {/* Eyebrow */}
        <p className="text-xs md:text-sm font-bold tracking-[0.2em] text-brand-red uppercase mb-5 md:mb-8 mt-3 md:mt-0" data-id="element-157">
          PROFE LISTO · ITALIANO 360
        </p>

        {/* Massive Bold Sans Headline */}
        <h1 className="font-sans font-black text-[#1A1A1A] tracking-[-0.02em] text-[36px] leading-[1.05] md:text-6xl lg:text-7xl md:leading-[1.02] mb-2 md:mb-4" data-id="element-158">
          Todo tu año de italiano resuelto de una vez.
        </h1>

        {/* Product Image */}
        <div className="relative mb-2 md:mb-4 mx-auto" data-id="element-159">
          <img src="https://cdn.magicpatterns.com/uploads/cwSy63G96Qknr9ysQsrJmE/278.png" alt="Megapack ITALIANO 360" className="relative w-full h-auto object-contain drop-shadow-xl" width="800" height="800" decoding="async"
        // @ts-expect-error: fetchPriority is valid HTML
        fetchpriority="high" data-id="element-160" />
        </div>

        {/* Description */}
        <p className="text-base md:text-xl text-gray-500 mb-8 md:mb-10 max-w-xl mx-auto leading-relaxed" data-id="element-161">
          Megapack ITALIANO 360 — El sistema completo de materiales y
          planificación para el profesor de italiano argentino
        </p>

        {/* Feature pills with separators */}
        <div className="flex flex-wrap justify-center items-center gap-2 md:gap-3 mb-8 md:mb-10" data-id="element-162">
          <span className="inline-flex items-center bg-white border border-gray-200 rounded-full px-3.5 py-2 text-xs md:text-sm font-semibold text-gray-700 shadow-sm" data-id="element-163">
            <FileText className="w-4 h-4 mr-2 text-gray-500" data-id="element-164" />
            📄 PDF
          </span>
          <span className="hidden md:inline text-gray-300" data-id="element-165">|</span>
          <span className="inline-flex items-center bg-white border border-gray-200 rounded-full px-3.5 py-2 text-xs md:text-sm font-semibold text-gray-700 shadow-sm" data-id="element-166">
            <Zap className="w-4 h-4 mr-2 text-yellow-500" data-id="element-167" />
            Acceso Inmediato
          </span>
          <span className="hidden md:inline text-gray-300" data-id="element-168">|</span>
          <span className="inline-flex items-center bg-white border border-gray-200 rounded-full px-3.5 py-2 text-xs md:text-sm font-semibold text-gray-700 shadow-sm" data-id="element-169">
            <BookOpen className="w-4 h-4 mr-2 text-brand-green" data-id="element-170" />
            12 Tomos + 6 Bonus + 2 Elite
          </span>
        </div>

        {/* Full-width CTA */}
        <div className="mb-5 md:mb-6 max-w-md mx-auto" data-id="element-171">
          <Button href="#pricing" size="lg" fullWidth className="!bg-[#C76F4A] hover:!bg-[#B05C3A] text-white text-base md:text-lg py-4 md:py-5 shadow-xl shadow-[#C76F4A]/30 rounded-2xl" data-id="element-172">
            💪 QUIERO MI ITALIANO 360 AHORA
          </Button>
        </div>

        {/* Trust row */}
        <div className="flex flex-wrap justify-center items-center gap-x-3 md:gap-x-5 gap-y-1.5 text-[11px] md:text-sm text-gray-500" data-id="element-173">
          <span className="flex items-center" data-id="element-174">
            🛡️ <span className="ml-1.5" data-id="element-175">Garantía 7 días</span>
          </span>
          <span className="text-gray-300" data-id="element-176">|</span>
          <span className="flex items-center" data-id="element-177">
            🔒 <span className="ml-1.5" data-id="element-178">Pago seguro</span>
          </span>
          <span className="text-gray-300" data-id="element-179">|</span>
          <span className="flex items-center" data-id="element-180">
            💳 <span className="ml-1.5" data-id="element-181">Tarjetas y transferencia</span>
          </span>
        </div>
      </div>
    </section>;
}